BaseManager = require 'BaseManager'
howler = require 'howler/dist/howler.js'
log = require 'loglevel'

###############################################

class SoundManager extends BaseManager

  name: 'SoundManager'
  timer: null
  ids: {}

  # -------------------------------------------
  #
  # Setup options
  #
  # masterVolume: the volume of all tracks
  # volumes: the volume of the individual tracks
  # mute: is playback silent
  # audioSpriteObj: json sprite sheet object (see Howler docs)
  # mp3: url to the audio mp3 files
  # ogg: url to the audio ogg files
  #

  setup: (options) ->
    @masterVolume = options.masterVolume
    @volumes = options.volumes
    @mute = options.mute
    @audioSpriteObj = options.audioSpriteObj
    @mp3 = options.mp3
    @ogg = options.ogg

    # add some features to Howler
    @extend()

  # -------------------------------------------
  #
  # Create and start the audio, additionally start BG playback
  #
  startAudio: ->
    @sound = new Howl
      src: [@ogg,@mp3]
      volume: @masterVolume
      mute: @mute
      sprite: @audioSpriteObj.sprite

      onloaderror: =>
        log.error @name, 'loadSounds', 'failed'

      onload: =>
        log.info @name, 'loadedSounds'
        @bg() # start bg audio

    @sound

  # -------------------------------------------

  setMute: (newValue) ->

    @mute = newValue

    if @sound?
      @sound.mute newValue
      @resumeAll()

  # -------------------------------------------

  play: (key, vol = null) ->
    if @sound?
      id = @sound.play key

      @sound.volume(vol * @masterVolume, id) if vol?
      @ids[key] = id
      id

  # -------------------------------------------

  pauseAll: ->
    @sound.pause() if @sound?

  # -------------------------------------------

  resumeAll: ->

    @sound.unpause(@volumes) if @sound?

  # -------------------------------------------

  stopAll: ->
    @sound.stop() if @sound?

  # -------------------------------------------

  stop: (key) ->
    @sound.killByName key if @sound?

  # -------------------------------------------

  resume: (key) ->

    id = @ids[key]
    return if not @sound? and not id?
    @sound.play(id)

  # -------------------------------------------

  pause: (key) ->

    id = @ids[key]
    return if not sound? and not id?
    @sound.pause(id)

  # -------------------------------------------

  fade: (key, from, to, d=2000) ->
    id = @ids[key]
    return if not sound? and not id?
    @sound.fade from * @masterVolume, to * @masterVolume, d, id

  # -------------------------------------------

  bg: ->
    @play 'music', @volumes.music

  # -------------------------------------------

  stopBg: ->
    @stop 'music'

  # -------------------------------------------

  click: ->
    @play 'click', @volumes.click

  # -------------------------------------------

  reveal: ->
    @stopRevealShort()
    return if @sound.isPlayingByName 'reveal'
    @play 'reveal', @volumes.reveal

  # -------------------------------------------

  stopReveal: ->
   @stop 'reveal'

  # -------------------------------------------

  revealShort: ->
    return if @sound.isPlayingByName 'reveal-shortest'
    @play 'reveal-shortest', @volumes.reveal

  # -------------------------------------------

  stopRevealShort: ->
   @stop 'reveal-shortest'

  # -------------------------------------------

  loss: ->
    if @sound._sprite['loss']?
      @play 'loss', @volumes.loss

  # -------------------------------------------

  win: (key) ->
    key = 'win' unless key?
    @play key, @volumes.win

  # -------------------------------------------

  stopWin: ->
    @stop 'win'

  # -------------------------------------------

  bigWin: ->

    @play 'big-win', @volumes.bigWin
    # @fade 'music', @volumes.music, 0, 1000
    @stopBg()

    @timer = setTimeout =>
      @stopBigWin()
    , @sound._sprite['big-win'][1] - 1000

  # -------------------------------------------

  stopBigWin: ->
    clearTimeout @timer

    if @sound.isPlayingByName 'big-win'
      @stop 'big-win'
      @bg()

  # -------------------------------------------

  extend: ->

    Howl::unpause = (volumes) ->
      self = this
      id = undefined
      num = 0
      i = 0
      while i < self._sounds.length
        if self._sounds[i]._paused and !self._sounds[i]._ended
          track = self._sounds[i]
          num++
          id = track._id

          self.play id, volumes[track._sprite]
        i++
      self

    Howl::killByName = (name) ->
      self = this
      id = undefined
      track = undefined
      i = 0
      while i < self._sounds.length
        track = self._sounds[i]
        if track._sprite? and track._sprite is name
          id = self._sounds[i]._id
          self.stop id
        i++
      self

    Howl::isPlayingByName = (name) ->
      self = this
      id = undefined
      track = undefined
      i = 0
      while i < self._sounds.length
        track = self._sounds[i]
        if track._sprite? and track._sprite is name and !track._paused and !track._ended
          return true
        i++
      return false


  # -------------------------------------------

  isSetup: ->
    @sound?

module.exports = SoundManager.getInstance()



// WEBPACK FOOTER //
// ./coffee/manager/sound-manager.coffee